import { useSuspenseQuery } from "@apollo/client";
import { useParams } from "react-router";
import { WASTE_LINES_UNIFIED_QUERY } from "routes/Customer/Waste/ManifestLineItems/Preview/api";

import { useCurrentUser } from "./useCurrentUser";

export const useWasteLineUnifiedSuspense = (wasteLineUnifiedId: string | undefined) => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const { isStaff, loading: userLoading } = useCurrentUser();
  const { data } = useSuspenseQuery(WASTE_LINES_UNIFIED_QUERY, {
    variables: {
      search: `tenantId:${tenantId} id:${wasteLineUnifiedId}`,
      page: 0,
      pageSize: 1,
      includeOriginalVendorWasteLine: isStaff,
    },
    skip: !tenantId || !wasteLineUnifiedId || userLoading,
  });

  return {
    data,
    lineItem: data?.wasteLinesUnified?.items?.[0],
  };
};
